const ferries = {
  ferry: "Traversier", // translated
  ferries: "Ferries", // translated
  selectOriginPort: "Sélectionnez le port d'origine", // translated
  selectDestPort: "Sélectionnez le port de destination", // translated
  continue: "Continuer", // translated
  viewTimetables: "Voir les horaires", // translated
  operator: "Opérateur", // translated
  cabin: "Cabine", // translated
  cabins: "Cabines", // translated
  place: "Lieu", // translated
  places: "Lieux", // translated
  seat: "Siège", // translated
  seats: "Des places", // translated
  seating: "Sièges", // translated
  deckSpace: "Espace sur le pont", // translated
  compulsory: "obligatoire", // translated
  departure: "Départ", // translated
  total: "Total", // translated
  back: "Dos", // translated
  next: "Suivant", // translated
  duration: "Durée", // translated
  return: "Retour", // translated
  prebook: "Pré-réservation", // translated
  travelInfo: "Informations de voyage", // translated
  book: "Livre", // translated
  adults: "Adultes", // translated
  child: "Enfant", // translated
  seniors: "Personnes âgées", // translated
  senior: "Senior", // translated
  to: "à", // translated
  passenger: "Passager", // translated
  details: "Détails", // translated
  currencyForTickets: "La devise de ces billets sera", // translated
  seatsError: "Le nombre de passagers n'est pas égal à la capacité.", // translated
  title: "Titre", // translated
  firstName: "Prénom", // translated
  lastName: "Nom de famille", // translated
  email: "E-mail", // translated
  phone: "Téléphone", // translated
  dateOfBirth: "Date de naissance", // translated
  placeOfBirth: "Lieu de naissance", // translated
  groupLeader: "Chef de groupe", // translated
  isRequired: "Est requis", // translated
  charactersOnly: "Caractères uniquement", // translated
  latinCharactersAndSpacesOnly: "Caractères latins et espaces uniquement", // translated
  validEmail: "Pas un email valide", // translated
  atLeastOneAdult: "Au moins 1 adulte est requis.", // translated
  atLeastOneSenior: "Au moins 1 senior est requis.", // translated
  toastAlert: "Veuillez corriger toutes les erreurs dans les formulaires ci-dessous.", // translated
  backToFerriesList: "Retour à la liste des ferries", // translated
  bestPrice: "Meilleur prix", // translated
  fastest: "Le plus rapide", // translated
  beforeDeparture: "Avant le départ", // translated
  perPerson: "par personne", // translated
  notAvailableForOnlineBooking: "Non disponible pour la réservation en ligne", // translated
  hurryLimitedAvailability: "Dépêche-toi! Disponibilité limitée", // translated
  berth: "Couchette", // translated
  berths: "Couchettes", // translated
  sumOfSelectionNotEqualToPersons: "La somme de votre sélection n'est pas égale au nombre de passagers", // translated
  attemptToBook: "Vous avez tenté de réserver un total de", // translated
  seatsWhenYouHave: "des sièges quand vous avez", // translated
  passengersTravelling: "passagers voyageant", // translated
  withReturn: "avec billets aller-retour", // translated
  pleaseCorrectYourSelection: "Veuillez corriger votre sélection", // translated
  pleaseSelectUpTo: "Veuillez sélectionner jusqu'à", // translated
  accommodationTypes: "types d'hébergement", // translated
  selectionPrices: "Tarifs de sélection", // translated
  yourCurrentTicket: "Votre type de billet actuel est", // translated
  upgradeTo: "Mettre à niveau vers", // translated
  wouldYouLikeToUpgrade: "Souhaitez-vous surclasser votre type de billet ?", // translated
  backToTicketTypes: "Retour aux types de billets", // translated
  originPort: "Port d'origine", // translated
  destinationPort: "Le port de destination", // translated
  outboundDate: "Date de sortie", // translated
  inboundDate: "Date d'arrivée", // translated
  passengers: "Passagers", // translated
  hasReturn: "A un retour", // translated
  passportNumber: "Numéro de passeport", // translated
  passportExpiryDate: "date d'expiration du passeport", // translated
  passportPlaceOfIssue: "Lieu de délivrance du passeport", // translated
  passportStartDate: "Date de début du passeport", // translated
  cityCode: "Code de la ville", // translated
};


export default ferries;
